<template>
  <div class="invite-page">
    <!-- 邀请码卡 -->
    <el-card class="invite-card" shadow="never">
      <div class="invite-hero">
        <div class="hero-left">
          <div class="emoji">🍵</div>
          <div>
            <div class="title">请同行喝茶，一起赚钱</div>
            <div class="sub">好友通过你的邀请码注册，双方都有奖励</div>
          </div>
        </div>
        <div class="code-box" @click="copyCode">
          <div class="code">{{ invite_code || '------' }}</div>
          <div class="copy-hint">点击复制邀请码</div>
        </div>
      </div>
      <el-descriptions :column="3" border class="rewards">
        <el-descriptions-item label="好友注册">你得 <b>+30</b> 推广点</el-descriptions-item>
        <el-descriptions-item label="好友首充">你得 <b>15%</b> 返佣</el-descriptions-item>
        <el-descriptions-item label="好友开会员">你得 <b>20%</b> 返佣</el-descriptions-item>
        <el-descriptions-item label="好友7天活跃">你再得 <b>+30</b> 点</el-descriptions-item>
        <el-descriptions-item label="好友注册即送">20 体验点</el-descriptions-item>
        <el-descriptions-item label="每月返佣上限">1000 推广点</el-descriptions-item>
      </el-descriptions>
      <div class="invite-link">
        <span>邀请链接：</span>
        <code>{{ inviteLink }}</code>
        <el-button size="small" type="primary" plain @click="copyLink">复制</el-button>
      </div>
      <div class="poster">
        <div class="poster-tools">
          <el-radio-group v-model="posterSize" size="small">
            <el-radio-button label="3:4">3:4 群发</el-radio-button>
            <el-radio-button label="1:1">1:1 朋友圈</el-radio-button>
            <el-radio-button label="9:16">9:16 全屏</el-radio-button>
          </el-radio-group>
          <el-button type="primary" :loading="genLoading" @click="genPoster">🖼️ 生成邀请海报</el-button>
          <el-button type="warning" plain @click="$refs.wxInput.click()">📱 上传我的微信二维码</el-button>
          <input ref="wxInput" type="file" accept="image/*" style="display:none" @change="uploadWx" />
        </div>
        <div class="wx-tip" v-if="wxUploaded">✅ 已使用你的微信二维码，长按保存海报即可分享</div>
        <img v-if="posterUrl" :src="posterUrl" class="poster-img" alt="邀请海报" />
      </div>
    </el-card>

    <!-- 推广数据 -->
    <el-card shadow="never">
      <template #header><span>📊 我的推广数据</span></template>
      <el-descriptions :column="4" border>
        <el-descriptions-item label="推广点余额">{{ promo.balance }} 点</el-descriptions-item>
        <el-descriptions-item label="邀请人数">{{ promo.invited_count }} 人</el-descriptions-item>
        <el-descriptions-item label="累计返佣">{{ promo.total_reward }} 点</el-descriptions-item>
        <el-descriptions-item label="本月返佣">{{ promo.month_reward }} 点</el-descriptions-item>
      </el-descriptions>
      <el-table :data="invites" size="small" empty-text="还没有邀请记录" class="invite-table">
        <el-table-column prop="phone" label="好友手机号" min-width="120" />
        <el-table-column prop="reward" label="奖励(点)" width="90" />
        <el-table-column prop="action" label="来源" width="150" />
        <el-table-column prop="created_at" label="时间" width="160" />
      </el-table>
    </el-card>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'Invite',
  data() {
    return {
      userId: Number(localStorage.getItem('user_id') || 0),
      invite_code: localStorage.getItem('invite_code') || '',
      inviteLink: '',
      promo: { balance: 0, invited_count: 0, total_reward: 0, month_reward: 0 },
      invites: [],
      posterUrl: '',
      genLoading: false,
      posterSize: '3:4',
      wxUploaded: false
    }
  },
  created() { this.load() },
  methods: {
    async load() {
      try {
        const r = await api.get(`/auth/invite/${this.userId}`)
        this.invite_code = r.invite_code || this.invite_code
        this.promo = { balance: r.promo_balance || 0, invited_count: r.invited_count || 0, total_reward: r.total_reward || 0, month_reward: r.month_reward || 0 }
        this.invites = r.invites || []
        localStorage.setItem('invite_code', this.invite_code)
        this.inviteLink = r.invite_link || `${location.origin}/#/login?invite=${this.invite_code}`
      } catch (e) { this.$message.error(e.message) }
    },
    async copyCode() {
      try {
        await navigator.clipboard.writeText(this.invite_code)
        this.$message.success('邀请码已复制：' + this.invite_code)
      } catch (e) { this.$message.warning('复制失败，请手动复制：' + this.invite_code) }
    },
    async copyLink() {
      try {
        await navigator.clipboard.writeText(this.inviteLink)
        this.$message.success('邀请链接已复制')
      } catch (e) { this.$message.warning('复制失败') }
    },
    async genPoster() {
      this.genLoading = true
      try {
        const r = await api.get(`/auth/invite-poster/${this.userId}`, { params: { size: this.posterSize }, responseType: 'blob' })
        this.posterUrl = URL.createObjectURL(r)
        this.$message.success('海报已生成，长按/右键保存图片')
      } catch (e) { this.$message.error(e.message) } finally { this.genLoading = false }
    },
    async uploadWx(e) {
      const file = e.target.files && e.target.files[0]
      if (!file) return
      const fd = new FormData()
      fd.append('user_id', this.userId)
      fd.append('file', file)
      try {
        await api.post('/auth/upload-wx-qr', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
        this.wxUploaded = true
        this.posterUrl = ''
        this.$message.success('微信二维码已上传，之后生成的海报将使用你自己的二维码')
      } catch (err) { this.$message.error(err.message) }
      e.target.value = ''
    }
  }
}
</script>

<style scoped>
.invite-page { display: flex; flex-direction: column; gap: 16px; }
.invite-hero { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; flex-wrap: wrap; gap: 12px; }
.hero-left { display: flex; align-items: center; gap: 14px; }
.hero-left .emoji { font-size: 40px; }
.hero-left .title { font-size: 20px; font-weight: 700; }
.hero-left .sub { color: #8b949e; font-size: 13px; margin-top: 4px; }
.code-box { background: linear-gradient(135deg, #10b981, #059669); color: #fff; border-radius: 12px; padding: 14px 26px; text-align: center; cursor: pointer; }
.code-box .code { font-size: 26px; font-weight: 800; letter-spacing: 4px; }
.code-box .copy-hint { font-size: 12px; opacity: 0.85; margin-top: 4px; }
.rewards { margin-bottom: 14px; }
.invite-link { display: flex; align-items: center; gap: 8px; color: #8b949e; font-size: 13px; margin-bottom: 14px; }
.invite-link code { background: #1f2937; padding: 4px 10px; border-radius: 6px; font-size: 12px; word-break: break-all; }
.poster { text-align: center; }
.poster-tools { display: flex; justify-content: center; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 4px; }
.wx-tip { color: #67c23a; font-size: 13px; margin-top: 8px; }
.poster-img { max-width: 320px; margin-top: 14px; border-radius: 10px; box-shadow: 0 4px 16px rgba(0,0,0,0.3); }
.invite-table { margin-top: 14px; }
</style>
